import { CommunicationConfigService } from '../communication-config/communication-config.service';
import { ConfigService } from '../config/config.service';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class MainConfigService {
  constructor(
    private communicationConfigService: CommunicationConfigService,
    private ConfigService: ConfigService,
    private http: HttpClient
  ) {}

  getLogoOf(): Observable<any> {
    if (!this.ConfigService.getOptions()) {
      return of('https://wisolv.com/images/Wisolv.png');
    } else {
      return this.http.get<any>(`${this.communicationConfigService.getApiUri()}/config/logo-of`);
    }
  }
}
